{
  "STRICTLY_NECESSARY": [
    {
      "col1": "gousto_session_id",
      "col2": "Stores session id",
      "is_regex": false
    },
    {
      "col1": "v1_goustoStateStore_features",
      "col2": "Stores the list of feature flags",
      "is_regex": false
    },
    {
      "col1": "v1_goustoStateStore_promoAgeVerified",
      "col2": "Stores promocode validity",
      "is_regex": false
    },
    {
      "col1": "v1_goustoStateStore_basket_postcode",
      "col2": "Stores postcode for the current order in the basket",
      "is_regex": false
    },
    {
      "col1": "v1_goustoStateStore_basket_date",
      "col2": "Stores delivery date for the current order in the basket",
      "is_regex": false
    },
    {
      "col1": "v1_goustoStateStore_basket_address",
      "col2": "Stores delivery address for the current order in the basket",
      "is_regex": false
    },
    {
      "col1": "v1_goustoStateStore_basket_numPortions",
      "col2": "Stores number of portions for the current order in the basket",
      "is_regex": false
    },
    {
      "col1": "v1_goustoStateStore_basket_slotId",
      "col2": "Stores information on the delivery slot for the current order in the basket",
      "is_regex": false
    },
    {
      "col1": "v1_goustoStateStore_basket_recipes",
      "col2": "Stores recipes for the current order in the basket",
      "is_regex": false
    },
    {
      "col1": "v1_goustoStateStore_basket_promoCode",
      "col2": "Stores the promo code for the current order in the basket",
      "is_regex": false
    },
    {
      "col1": "v1_goustoStateStore_basket_subscriptionOption",
      "col2": "Stores subscription option for the current order in the basket",
      "is_regex": false
    },
    {
      "col1": "v1_goustoStateStore_menu_selectedRecipeVariants",
      "col2": "Stores details of ingredient swaps for the current order",
      "is_regex": false
    },
    {
      "col1": "v1_goustoStateStore_menu_curatedBoxName",
      "col2": "Stores details of a selected curated box",
      "is_regex": false
    },
    {
      "col1": "v1_goustoStateStore_menu_curatedBoxCollectionId",
      "col2": "Stores the ID of a selected curated box (box with pre-celected recipes)",
      "is_regex": false
    },
    {
      "col1": "v1_goustoStateStore_deliveryDetails_deliveryInstruction",
      "col2": "Stores delivery instructions",
      "is_regex": false
    },
    {
      "col1": "v1_goustoStateStore_deliveryDetails_deliveryInstructionCustom",
      "col2": "Stores custom delivery instructions",
      "is_regex": false
    },
    {
      "col1": "v1_oauth_expiry",
      "col2": "Used for authentication purposes",
      "is_regex": false
    },
    {
      "col1": "v1_oauth_refresh",
      "col2": "Used for authentication purposes",
      "is_regex": false
    },
    {
      "col1": "v1_oauth_remember",
      "col2": "Used for authentication purposes",
      "is_regex": false
    },
    {
      "col1": "v1_oauth_token",
      "col2": "Used for authentication purposes",
      "is_regex": false
    },
    {
      "col1": "v1_clientID",
      "col2": "Stores anonymous ID used for A/B testing",
      "is_regex": false
    },
    {
      "col1": "v1_gousto_cookie_consent",
      "col2": "Stores cookie preferences",
      "is_regex": false
    },
    {
      "col1": "__zlcmid",
      "col2": "Used for chat widget authentication",
      "is_regex": false
    },
    {
      "col1": "_GRECAPTCHA",
      "col2": "Used when reCAPTCHA is executed",
      "is_regex": false
    },
    {
      "col1": "AWSELBCORS",
      "col2": "AWS Classic Load Balancer Cookie",
      "is_regex": false
    },
    {
      "col1": "AWSALB",
      "col2": "AWS Classic Load Balancer Cookie",
      "is_regex": false
    },
    {
      "col1": "LANG",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "tsrce",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "datadome",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "ts",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "ts_c",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "cookie_prefs",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "rmuc",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "KHcl0EuY7AKSMgfvHl7J5E7hPtK",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "UGZUWCKM6F_awXE8WyEURJrBYQG",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "d_id",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "cookie_check",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "ddi",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "sc_f",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "enforce_policy",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "x-pp-s",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "nsid",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "TfXMWj95u2_Zf1Kmv_GCUOjlGG8",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "l7_az",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "ui-experience",
      "col2": "This cookie is required for PayPal to function on our website",
      "is_regex": false
    },
    {
      "col1": "NID",
      "col2": "Used by Google to remember your preferences and other information",
      "is_regex": false
    }
  ],
  "MARKETING": [
    {
      "col1": "v1_goustoStateStore_tracking",
      "col2": "Stores details of relevant marketing campaign for new customers",
      "is_regex": false
    },
    {
      "col1": "_gclxxxx",
      "col2": "Google Conversion tracking cookie",
      "is_regex": false
    },
    {
      "col1": "_gcl_au",
      "col2": "Used to store and track conversions",
      "is_regex": false
    },
    {
      "col1": "_ttp",
      "col2": "Used to measure performance of ad campaigns and personalise user experience",
      "is_regex": false
    },
    {
      "col1": "_tt_enable_cookie",
      "col2": "Used to measure performance of ad campaigns and personalise user experience",
      "is_regex": false
    },
    {
      "col1": "_fbp",
      "col2": "Used to measure performance of ad campaigns and personalise user experience",
      "is_regex": false
    },
    {
      "col1": "wd",
      "col2": "These cookies help deliver an optimal experience for your device's screen",
      "is_regex": false
    },
    {
      "col1": "usida",
      "col2": "Collects a combination of the user’s browser and unique identifier, used to tailor advertising to users",
      "is_regex": false
    },
    {
      "col1": "datr",
      "col2": "Fraud prevention",
      "is_regex": false
    },
    {
      "col1": "_tq_id\\.TV.+",
      "col2": "To measure impressions, reach and outcomes across linear and digital TV",
      "is_regex": true
    },
    {
      "col1": "_uetsid",
      "col2": "Bing Ads sets this cookie to engage with a user that has previously visited the website.",
      "is_regex": false
    },
    {
      "col1": "_uetvid",
      "col2": "Bing Ads sets this cookie to engage with a user that has previously visited the website.",
      "is_regex": false
    },
    {
      "col1": "MUID",
      "col2": "Microsoft User Identifier tracking cookie used by Bing Ads",
      "is_regex": false
    },
    {
      "col1": "_rdt_uuid",
      "col2": "Used to track visitors on multiple websites, in order to present relevant advertisement based on the visitor's preferences.",
      "is_regex": false
    },
    {
      "col1": "IDE",
      "col2": "Used to show Google ads on non-Google sites",
      "is_regex": false
    },
    {
      "col1": "ar_debug",
      "col2": "To store and track conversions",
      "is_regex": false
    },
    {
      "col1": "A1",
      "col2": "Used for providing Yahoo consumer services",
      "is_regex": false
    },
    {
      "col1": "A1S",
      "col2": "Used for providing Yahoo consumer services",
      "is_regex": false
    },
    {
      "col1": "A3",
      "col2": "Ads targeting cookie for Yahoo",
      "is_regex": false
    },
    {
      "col1": "_pinterest_ct_ua",
      "col2": "Groups actions for users who cannot be identified by Pinterest.",
      "is_regex": false
    },
    {
      "col1": "gdId",
      "col2": "The cookie ensures that the most relevant job postings are shown to the specific user.",
      "is_regex": false
    },
    {
      "col1": "gdsid",
      "col2": "The cookie ensures that the most relevant job postings are shown to the specific user",
      "is_regex": false
    },
    {
      "col1": "trs",
      "col2": "The cookie ensures that the most relevant job postings are shown to the specific user",
      "is_regex": false
    },
    {
      "col1": "GSESSIONID",
      "col2": "Used to track which users have shown interest in what job postings. The cookie ensures that the most relevant job postings are shown to the specific user",
      "is_regex": false
    },
    {
      "col1": "JSESSIONID",
      "col2": "Preserves users states across page requests",
      "is_regex": false
    },
    {
      "col1": "asst",
      "col2": "Used to track which users have shown interest in what job postings. The cookie ensures that the most relevant job postings are shown to the specific user.",
      "is_regex": false
    },
    {
      "col1": "__cf_bm",
      "col2": "This cookie is used to distinguish between humans and bots",
      "is_regex": false
    },
    {
      "col1": "_cfuvid",
      "col2": "This cookie is a part of the services provided by Cloudflare",
      "is_regex": false
    },
    {
      "col1": "cass",
      "col2": "Used to track which users have shown interest in what job postings. The cookie ensures that the most relevant job postings are shown to the specific user",
      "is_regex": false
    },
    {
      "col1": "__smToken",
      "col2": "Used to verify whether you are logged into Sumo or not",
      "is_regex": false
    },
    {
      "col1": "__smVID",
      "col2": "Used for sign-up prompt purposes",
      "is_regex": false
    }
  ],
  "FUNCTIONALITY": [
    {
      "col1": "v1_cookie_app_promotion",
      "col2": "Remembers whether app banner promotion was viewed ",
      "is_regex": false
    },
    {
      "col1": "v1_tutorial_viewed",
      "col2": "Remembers whether a user saw the menu tutorial",
      "is_regex": false
    }
  ],
  "ANALYTICS": [
    {
      "col1": "_dd_s",
      "col2": "Used to monitor the website for errors or performance issues you might encounter",
      "is_regex": false
    },
    {
      "col1": "_ga",
      "col2": "Used by Google Analytics to distinguish users",
      "is_regex": false
    },
    {
      "col1": "_ga_.+",
      "col2": "Used by Google Analytics to persist session state",
      "is_regex": true
    },
    {
      "col1": "_gid",
      "col2": "Used by Google Analytics to distinguish users",
      "is_regex": false
    },
    {
      "col1": "_dc_gtm_.+",
      "col2": "Used to throttle request rate",
      "is_regex": true
    },
    {
      "col1": "sp",
      "col2": "Stores a server-generated unique identifier that is sent with all subsequent tracking events for the same user",
      "is_regex": false
    },
    {
      "col1": "_sp_id_.+",
      "col2": "Stores user information that is created when a user first visits a site and updated on subsequent visits. It is used to identify users and analyse the users activity across a domain",
      "is_regex": true
    },
    {
      "col1": "_sp_ses_.+",
      "col2": "Used to identify if the user is in an active session on a site or if this is a new session for a user",
      "is_regex": true
    },
    {
      "col1": "_hjIncludedInSessionSample_.+",
      "col2": "Used to determine if a user is included in the data sampling",
      "is_regex": true
    },
    {
      "col1": "_hjSession_.+",
      "col2": "Holds current session data for Hotjar",
      "is_regex": true
    },
    {
      "col1": "_hjSessionUser_.+",
      "col2": "Ensures Hotjar data from subsequent visits to the same site are attributed to the same user",
      "is_regex": true
    },
    {
      "col1": "_hjAbsoluteSessionInProgress",
      "col2": "Used by Hotjar to detect the first pageview session of a user",
      "is_regex": false
    },
    {
      "col1": "optimizelyEndUserId",
      "col2": "Set by Optimizely Web Experimentation, stores a visitor's unique Optimizely Experimentation identifier.",
      "is_regex": false
    }
  ]
}